<script>
  import { data, activeCategory, activeCategoryItem } from '../stores';
  import {
    sum,
    sortByKey,
    formatNumber,
    getCategoryByKey,
    formatWeight
  } from '../utils';
  import { countryCol, categoryCol, weightCol, categories } from '../config';

  export let isoCode;

  $: visData = $data
    .filter(d => d[countryCol] === isoCode)
    // group by category and sum up weights
    .reduce((res, item) => {
      const itemCategory = item[categoryCol];
      if (itemCategory) {
        const matchingItem = res.find(r => r[categoryCol] === itemCategory);
        const weight = item[weightCol];

        if (matchingItem) {
          matchingItem.weight += weight;
          matchingItem.articleCount += 1;
        } else {
          res.push({
            [categoryCol]: itemCategory,
            weight,
            articleCount: 1
          });
        }
      }
      return res;
    }, [])
    .sort(sortByKey('weight', false));

  $: sumWeight = sum(visData, 'weight');
  $: sumArticle = sum(visData, 'articleCount');

  $: getColor = key => {
    if ($activeCategory && key !== $activeCategory) {
      return '#f3f3f3';
    }

    return getCategoryByKey(key).color;
  };

  $: activeVisDataItem = visData.find(d => d[categoryCol] === $activeCategory);

  const onClickBar = category =>
    activeCategory.set($activeCategory === category ? null : category);
</script>

<style>
  .km-vis {
    display: flex;
    width: 100%;
    margin: 5px 0;
  }

  .km-bar {
    height: 10px;
    border-right: 1px solid white;
    cursor: pointer;
  }

  .km-bar:hover {
    opacity: 0.8;
  }

  .km-info {
    color: #3a3a3a;
    font-size: 13px;
    letter-spacing: 0.25px;
  }

  .km-info > strong {
    color: #888;
  }
</style>

<div class="km-vis">
  {#each visData as d}
    <div
      class="km-bar"
      style={`width: ${(d.weight / sumWeight) * 100}%; background-color: ${getColor(d[categoryCol])}`}
      on:click={() => onClickBar(d[categoryCol])}
    />
  {/each}
</div>
{#if $activeCategory}
  <div class="km-info">
    {#if activeVisDataItem}
      <span>{activeVisDataItem.articleCount}</span>
      Artikel aus
      <span style="color: {getColor($activeCategory)};">
        {$activeCategoryItem.label}
      </span>
      <span nowrap style="color: #888;">
        {formatNumber((activeVisDataItem.weight / sumWeight) * 100, 2, '%')}
      </span>
    {:else}
      keine Artikel in der Kategorie
      <span style="color: {getColor($activeCategory)};">
        {$activeCategoryItem.label}
      </span>
    {/if}
  </div>
{:else}
  <div class="km-info">
    {formatWeight(sumWeight)}
    <strong>({sumArticle} Artikel)</strong>
  </div>
{/if}
